// extracted by mini-css-extract-plugin
export default {"img-preview":"NewsEditModal_img-preview__kcgg3","modal-select":"NewsEditModal_modal-select__MrQk-","is_main":"NewsEditModal_is_main__ft0EP"};